/**
 * Which emailed link the user arrived from. The two links carry different
 * Identity tokens, and each is only accepted by its own endpoint, so the value
 * doubles as the `/auth/<flow>` path segment.
 */
export enum SetPasswordFlow {
  ConfirmEmail = "confirm-email",
  ResetPassword = "reset-password",
}
